import { useSearchParams } from 'react-router-dom';
import { TOKEN_SEARCH_PARAM_NAME } from '@/constants/common.ts';

export const useToken = () => {
  const [params] = useSearchParams();
  return params.get(TOKEN_SEARCH_PARAM_NAME);
};
